import React from 'react';
import {Text, StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {LinearGradient} from 'expo-linear-gradient';
import i18n from 'i18n-js';
import {fontFamily} from '../../helpers/fontFamily';

const sumBy = (items, key) =>
  items.reduce((sum, item) => sum + (item[key] || 0), 0);

const ProgressHint = () => {
  const {itemsInTote, unscannedItems} = useSelector(state => ({
    itemsInTote: state.productFirst.itemsInTote,
    unscannedItems: state.productFirst.unscannedItems
  }));

  const placed = sumBy(itemsInTote, 'scanned_qty');
  const total = placed + sumBy(unscannedItems, 'qty_remaining');

  return (
    <LinearGradient
      colors={['#768da5', '#566f88', '#4A6179']}
      locations={[0, 0.5, 1]}
      style={styles.container}>
      <Text style={styles.placed}>
        {i18n.t('productFirst.progressPlaced', {count: placed, total})}
      </Text>
      <Text style={styles.hint}>{i18n.t('productFirst.progressLeftHint')}</Text>
      <Text style={styles.continue}>{i18n.t('productFirst.scanToContinue')}</Text>
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  container: {
    margin: 12,
    paddingVertical: 28,
    paddingHorizontal: 20,
    borderRadius: 12,
    alignItems: 'center'
  },
  placed: {
    color: '#fff',
    fontSize: 16,
    fontFamily: fontFamily.font600,
    textAlign: 'center',
    marginBottom: 14
  },
  hint: {
    color: '#eef3f9',
    fontSize: 14,
    fontFamily: fontFamily.font400,
    textAlign: 'center',
    marginBottom: 22
  },
  continue: {
    color: '#fff',
    fontSize: 24,
    fontFamily: fontFamily.font600,
    textAlign: 'center'
  }
});

export default ProgressHint;
